/* @ngInject */

export default (
  $rootScope,
  helperService,
  helperPdfService,
  assetsService,
  Asset,
  Address,
  BankAccountType,
  PropertyType,
  VehicleType,
  ZoningOption
) => {
  /**
   * Prepare owner occupied asset details.
   *
   * @param {Array} assets
   * @param {Array} contacts
   * @param {Array} homeLoanSecurities
   * @param {Object} workflow
   * @param {Number} count
   *
   * @returns {Array}
   */
  const prepareOwnerOccupiedAssetDetails = ({
    asset,
    contacts,
    homeLoanSecurities,
    workflow,
    count
  }) => {
    const content = [];
    content.push(
      helperPdfService.createSubHeader({
        title: `${asset.assetType.title.toUpperCase()} #${count}`
      })
    );
    if (helperService.getOrganizationCountry().cca2 !== 'NZ') {
      content.push({
        table: {
          widths: ['25%', '25%', '25%', '25%'],
          body: [
            [
              {
                text: [
                  { text: 'Address\n', style: 'label' },
                  {
                    text: Address.getAddress(asset?.address),
                    style: 'value'
                  }
                ],
                colSpan: 3
              },
              '',
              '',
              {
                text: [
                  { text: 'Value\n', style: 'label' },
                  {
                    text: helperService
                      .isNumber(asset?.value, true)
                      .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                    style: 'value'
                  }
                ]
              }
            ],
            [
              {
                text: [
                  { text: 'Property type\n', style: 'label' },
                  {
                    text:
                      asset?.propertyType?.name !== PropertyType.none.name
                        ? asset?.propertyType?.title || '-'
                        : '-',
                    style: 'value'
                  }
                ]
              },
              {
                text: [
                  { text: 'Zoning\n', style: 'label' },
                  {
                    text:
                      asset?.zoning?.name !== ZoningOption.none.name
                        ? asset?.zoning?.title || '-'
                        : '-',
                    style: 'value'
                  }
                ]
              },
              {
                text: !workflow.isAssetFinance()
                  ? [
                      { text: 'Valuation\n', style: 'label' },
                      {
                        text: asset?.valuation ? 'Certified valuation' : 'Applicant estimate',
                        style: 'value'
                      }
                    ]
                  : ''
              },
              {
                text: !workflow.isAssetFinance()
                  ? [
                      {
                        text: 'Will it become Investment after settlement?\n',
                        style: 'label'
                      },
                      {
                        text: asset?.willItBecomeInvestment ? 'Yes' : 'No',
                        style: 'value'
                      }
                    ]
                  : ''
              }
            ]
          ]
        },
        layout: 'noBorders'
      });

      if (!workflow.isAssetFinance()) {
        content[content.length - 1].table.body.push(['', '', '', '']);
        content[content.length - 1].table.body[2][0] = {
          text: [
            {
              text: 'To be sold\n',
              style: 'label'
            },
            {
              text: asset?.toBeSold ? 'Yes' : 'No',
              style: 'value'
            }
          ]
        };
        content[content.length - 1].table.body[2][1] = {
          text: [
            {
              text: 'Property used as security\n',
              style: 'label'
            },
            {
              text: helperService.isPropertyUsedAsSecurity({
                idAsset: asset?.id,
                securities: homeLoanSecurities
              })
                ? 'Yes'
                : 'No',
              style: 'value'
            }
          ]
        };
      }

      content[content.length - 1].table.body.push(['', '', '', '']);
      content[content.length - 1].table.body[!workflow.isAssetFinance() ? 3 : 2][0] = {
        text: [
          {
            text: 'Ownership\n',
            style: 'label'
          },
          {
            text: helperService.getOwnerships({
              contacts,
              ownership: asset.ownership
            }),
            style: 'value'
          }
        ],
        colSpan: 4
      };
    } else {
      content.push({
        table: {
          widths: ['25%', '25%', '25%', '25%'],
          body: [
            [
              {
                text: [
                  { text: 'Address\n', style: 'label' },
                  {
                    text: Address.getAddress(asset?.address),
                    style: 'value'
                  }
                ],
                colSpan: 3
              },
              '',
              '',
              {
                text: [
                  { text: 'Value\n', style: 'label' },
                  {
                    text: helperService
                      .isNumber(asset?.value, true)
                      .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                    style: 'value'
                  }
                ]
              }
            ],
            [
              {
                text: [
                  { text: 'Monthly boarder income\n', style: 'label' },
                  {
                    text: helperService
                      .isNumber(asset?.monthlyRentalIncome, true)
                      .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                    style: 'value'
                  }
                ]
              },
              {
                text: [
                  { text: 'Number of boarders\n', style: 'label' },
                  {
                    text: asset?.numberOfBoarders || 0,
                    style: 'value'
                  }
                ]
              },
              {
                text: [
                  {
                    text: 'All inclusive\n',
                    style: 'label'
                  },
                  {
                    text: asset?.allInclusive ? 'Yes' : 'No',
                    style: 'value'
                  }
                ]
              },
              {
                text: [
                  { text: 'Property type\n', style: 'label' },
                  {
                    text:
                      asset?.propertyType?.name !== PropertyType.none.name
                        ? asset?.propertyType?.title || '-'
                        : '-',
                    style: 'value'
                  }
                ]
              }
            ],
            [
              {
                text: [
                  { text: 'Zoning\n', style: 'label' },
                  {
                    text:
                      asset?.zoning?.name !== ZoningOption.none.name
                        ? asset?.zoning?.title || '-'
                        : '-',
                    style: 'value'
                  }
                ]
              },
              {
                text: !workflow.isAssetFinance()
                  ? [
                      { text: 'Valuation\n', style: 'label' },
                      {
                        text: asset?.valuation ? 'Certified valuation' : 'Applicant estimate',
                        style: 'value'
                      }
                    ]
                  : ''
              },
              {
                text: !workflow.isAssetFinance()
                  ? [
                      {
                        text: 'Will it become Investment after settlement?\n',
                        style: 'label'
                      },
                      {
                        text: asset?.willItBecomeInvestment ? 'Yes' : 'No',
                        style: 'value'
                      }
                    ]
                  : ''
              },
              {
                text: !workflow.isAssetFinance()
                  ? [
                      {
                        text: 'To be sold\n',
                        style: 'label'
                      },
                      {
                        text: asset?.toBeSold ? 'Yes' : 'No',
                        style: 'value'
                      }
                    ]
                  : ''
              }
            ]
          ]
        },
        layout: 'noBorders'
      });

      if (!workflow.isAssetFinance()) {
        content[content.length - 1].table.body.push(['', '', '', '']);
        content[content.length - 1].table.body[3][0] = {
          text: [
            {
              text: 'Property used as security\n',
              style: 'label'
            },
            {
              text: helperService.isPropertyUsedAsSecurity({
                idAsset: asset?.id,
                securities: homeLoanSecurities
              })
                ? 'Yes'
                : 'No',
              style: 'value'
            }
          ]
        };
      }

      content[content.length - 1].table.body.push(['', '', '', '']);
      content[content.length - 1].table.body[!workflow.isAssetFinance() ? 4 : 3][0] = {
        text: [
          {
            text: 'Ownership\n',
            style: 'label'
          },
          {
            text: helperService.getOwnerships({
              contacts,
              ownership: asset.ownership
            }),
            style: 'value'
          }
        ],
        colSpan: 4
      };
    }
    return content;
  };

  /**
   * Prepare investment asset details.
   *
   * @param {Array} assets
   * @param {Array} contacts
   * @param {Array} homeLoanSecurities
   * @param {Object} workflow
   * @param {Number} count
   *
   * @returns {Array}
   */
  const prepareInvestmentAssetDetails = ({
    asset,
    contacts,
    homeLoanSecurities,
    workflow,
    count
  }) => {
    const content = [];
    content.push(
      helperPdfService.createSubHeader({
        title: `${asset.assetType.title.toUpperCase()} #${count}`
      })
    );
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                { text: 'Address\n', style: 'label' },
                {
                  text: Address.getAddress(asset?.address),
                  style: 'value'
                }
              ],
              colSpan: 3
            },
            '',
            '',
            {
              text: [
                { text: 'Value\n', style: 'label' },
                {
                  text: helperService
                    .isNumber(asset?.value, true)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ]
            }
          ],
          [
            {
              text: [
                { text: 'Monthly rental income\n', style: 'label' },
                {
                  text: helperService
                    .isNumber(asset?.monthlyRentalIncome, true)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ]
            },
            {
              text: [
                { text: 'Property type\n', style: 'label' },
                {
                  text:
                    asset?.propertyType?.name !== PropertyType.none.name
                      ? asset?.propertyType?.title || '-'
                      : '-',
                  style: 'value'
                }
              ]
            },
            {
              text: [
                { text: 'Zoning\n', style: 'label' },
                {
                  text:
                    asset?.zoning?.name !== ZoningOption.none.name
                      ? asset?.zoning?.title || '-'
                      : '-',
                  style: 'value'
                }
              ]
            },
            {
              text: !workflow.isAssetFinance()
                ? [
                    { text: 'Valuation\n', style: 'label' },
                    {
                      text: asset?.valuation ? 'Certified valuation' : 'Applicant estimate',
                      style: 'value'
                    }
                  ]
                : [{ text: '' }]
            }
          ]
        ]
      },
      layout: 'noBorders'
    });

    if (!workflow.isAssetFinance()) {
      content[content.length - 1].table.body.push(['', '', '', '']);
      content[content.length - 1].table.body[2][0] = {
        text: [
          {
            text: 'Will it become Owner occupied after settlement?\n',
            style: 'label'
          },
          {
            text: asset?.willItBecomeOwnerOccupied ? 'Yes' : 'No',
            style: 'value'
          }
        ]
      };
      content[content.length - 1].table.body[2][1] = {
        text: [
          {
            text: 'To be sold\n',
            style: 'label'
          },
          {
            text: asset?.toBeSold ? 'Yes' : 'No',
            style: 'value'
          }
        ]
      };
      content[content.length - 1].table.body[2][2] = {
        text: [
          {
            text: 'Property used as security\n',
            style: 'label'
          },
          {
            text: helperService.isPropertyUsedAsSecurity({
              idAsset: asset?.id,
              securities: homeLoanSecurities
            })
              ? 'Yes'
              : 'No',
            style: 'value'
          }
        ]
      };
    }
    content[content.length - 1].table.body.push(['', '', '', '']);
    content[content.length - 1].table.body[!workflow.isAssetFinance() ? 3 : 2][0] = {
      text: [
        {
          text: 'Ownership\n',
          style: 'label'
        },
        {
          text: helperService.getOwnerships({
            contacts,
            ownership: asset.ownership
          }),
          style: 'value'
        }
      ],
      colSpan: 4
    };

    return content;
  };

  /**
   * Prepare vehicle asset details.
   *
   * @param {Array} assets
   * @param {Array} contacts
   * @param {Number} count
   *
   * @returns {Array}
   */
  const prepareVehicleAssetDetails = ({ asset, contacts, count }) => {
    const content = [];
    content.push(
      helperPdfService.createSubHeader({
        title: `${asset.assetType.title} #${count}`
      })
    );
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                { text: 'Vehicle type\n', style: 'label' },
                {
                  text:
                    asset?.vehicleType?.name !== VehicleType.none.name
                      ? asset?.vehicleType?.title || '-'
                      : '-',
                  style: 'value'
                }
              ]
            },
            {
              text: [
                { text: 'Vehicle make and model\n', style: 'label' },
                {
                  text: asset?.name || '-',
                  style: 'value'
                }
              ]
            },
            {
              text: [
                { text: 'Estimated vehicle compliance date\n', style: 'label' },
                {
                  text: asset.getSetVehicleBuildDate(
                    $rootScope.CurrentTimeZone(),
                    $rootScope.CurrentLocale()
                  ),
                  style: 'value'
                }
              ]
            },
            {
              text: [
                { text: 'Value\n', style: 'label' },
                {
                  text: helperService
                    .isNumber(asset?.value, true)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ]
            }
          ],
          [
            {
              text: [
                {
                  text: 'Ownership\n',
                  style: 'label'
                },
                {
                  text: helperService.getOwnerships({
                    contacts,
                    ownership: asset.ownership
                  }),
                  style: 'value'
                }
              ],
              colSpan: 4
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });
    return content;
  };

  /**
   * Prepare bank account asset details.
   *
   * @param {Array} assets
   * @param {Array} contacts
   * @param {Array} lenders
   * @param {Number} count
   *
   * @returns {Array}
   */
  const prepareBankAccountAssetDetails = ({ asset, contacts, lenders, count }) => {
    const content = [];
    content.push(
      helperPdfService.createSubHeader({
        title: `${asset.assetType.title.toUpperCase()} #${count}`
      })
    );
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                { text: 'Bank\n', style: 'label' },
                {
                  text: helperService.getLenderByContentType({
                    lenders,
                    lenderAbbr: asset?.name,
                    lenderOtherName: asset?.bankOtherName,
                    contentType: 'abbr'
                  }),
                  style: 'value'
                }
              ]
            },
            {
              text: [
                { text: 'Bank account type\n', style: 'label' },
                {
                  text:
                    asset?.bankAccountType?.name !== BankAccountType.none.name
                      ? asset?.bankAccountType?.title || '-'
                      : '-',
                  style: 'value'
                }
              ]
            },
            {
              text: [
                { text: 'Value\n', style: 'label' },
                {
                  text: helperService
                    .isNumber(asset?.value, true)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ]
            },
            ''
          ],
          [
            {
              text: [
                {
                  text: 'Ownership\n',
                  style: 'label'
                },
                {
                  text: helperService.getOwnerships({
                    contacts,
                    ownership: asset.ownership
                  }),
                  style: 'value'
                }
              ],
              colSpan: 4
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });
    return content;
  };

  /**
   * Prepare home contents asset details.
   *
   * @param {Array} assets
   * @param {Array} contacts
   * @param {Number} count
   *
   * @returns {Array}
   */
  const prepareHomeContentsAssetDetails = ({ asset, contacts, count }) => {
    const content = [];
    content.push(
      helperPdfService.createSubHeader({
        title: `${asset.assetType.title.toUpperCase()} #${count}`
      })
    );
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                { text: 'Home contents\n', style: 'label' },
                {
                  text: asset?.name || '-',
                  style: 'value'
                }
              ]
            },
            {
              text: [
                { text: 'Value\n', style: 'label' },
                {
                  text: helperService
                    .isNumber(asset?.value, true)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ]
            },
            '',
            ''
          ],
          [
            {
              text: [
                {
                  text: 'Ownership\n',
                  style: 'label'
                },
                {
                  text: helperService.getOwnerships({
                    contacts,
                    ownership: asset.ownership
                  }),
                  style: 'value'
                }
              ],
              colSpan: 4
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });
    return content;
  };

  /**
   * Prepare kiwiSaver asset details.
   *
   * @param {Array} assets
   * @param {Array} contacts
   * @param {Number} count
   *
   * @returns {Array}
   */
  const prepareKiwiSaverAssetDetails = ({ asset, contacts, count }) => {
    const content = [];
    content.push(
      helperPdfService.createSubHeader({
        title: `${asset.assetType.title.toUpperCase()} #${count}`
      })
    );
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                { text: 'KiwiSaver\n', style: 'label' },
                {
                  text: asset?.name || '-',
                  style: 'value'
                }
              ]
            },
            {
              text: [
                { text: 'Value\n', style: 'label' },
                {
                  text: helperService
                    .isNumber(asset?.value, true)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ]
            },
            '',
            ''
          ],
          [
            {
              text: [
                {
                  text: 'Ownership\n',
                  style: 'label'
                },
                {
                  text: helperService.getOwnerships({
                    contacts,
                    ownership: asset.ownership
                  }),
                  style: 'value'
                }
              ],
              colSpan: 4
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });
    return content;
  };

  /**
   * Prepare superfund asset details.
   *
   * @param {Array} assets
   * @param {Array} contacts
   * @param {Number} count
   *
   * @returns {Array}
   */
  const prepareSuperfundAssetDetails = ({ asset, contacts, count }) => {
    const content = [];
    content.push(
      helperPdfService.createSubHeader({
        title: `${asset.assetType.title.toUpperCase()} #${count}`
      })
    );
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                { text: 'Superfund institution\n', style: 'label' },
                {
                  text: asset?.name || '-',
                  style: 'value'
                }
              ]
            },
            {
              text: [
                { text: 'Membership number\n', style: 'label' },
                {
                  text: asset?.membershipNumber || '-',
                  style: 'value'
                }
              ]
            },
            {
              text: [
                { text: 'Value\n', style: 'label' },
                {
                  text: helperService
                    .isNumber(asset?.value, true)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ]
            },
            ''
          ],
          [
            {
              text: [
                {
                  text: 'Ownership\n',
                  style: 'label'
                },
                {
                  text: helperService.getOwnerships({
                    contacts,
                    ownership: asset.ownership
                  }),
                  style: 'value'
                }
              ],
              colSpan: 4
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });
    return content;
  };

  /**
   * Prepare shares asset details.
   *
   * @param {Array} assets
   * @param {Array} contacts
   * @param {Number} count
   *
   * @returns {Array}
   */
  const prepareSharesAssetDetails = ({ asset, contacts, count }) => {
    const content = [];
    content.push(
      helperPdfService.createSubHeader({
        title: `${asset.assetType.title.toUpperCase()} #${count}`
      })
    );
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                { text: 'Shares\n', style: 'label' },
                {
                  text: asset?.name || '-',
                  style: 'value'
                }
              ]
            },
            {
              text: [
                { text: 'Value\n', style: 'label' },
                {
                  text: helperService
                    .isNumber(asset?.value, true)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ]
            },
            '',
            ''
          ],
          [
            {
              text: [
                {
                  text: 'Ownership\n',
                  style: 'label'
                },
                {
                  text: helperService.getOwnerships({
                    contacts,
                    ownership: asset.ownership
                  }),
                  style: 'value'
                }
              ],
              colSpan: 4
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });
    return content;
  };

  /**
   * Prepare other asset details.
   *
   * @param {Array} assets
   * @param {Array} contacts
   * @param {Number} count
   *
   * @returns {Array}
   */
  const prepareOtherAssetDetails = ({ asset, contacts, count }) => {
    const content = [];
    content.push(
      helperPdfService.createSubHeader({
        title: `${asset.assetType.title.toUpperCase()} #${count}`
      })
    );
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                { text: 'Other\n', style: 'label' },
                {
                  text: asset?.name || '-',
                  style: 'value'
                }
              ]
            },
            {
              text: [
                { text: 'Value\n', style: 'label' },
                {
                  text: helperService
                    .isNumber(asset?.value, true)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ]
            },
            '',
            ''
          ],
          [
            {
              text: [
                {
                  text: 'Ownership\n',
                  style: 'label'
                },
                {
                  text: helperService.getOwnerships({
                    contacts,
                    ownership: asset.ownership
                  }),
                  style: 'value'
                }
              ],
              colSpan: 4
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });
    return content;
  };

  /**
   * Prepare balance sheet asset details.
   *
   * @param {Array} assets
   * @param {Array} contacts
   * @param {Number} count
   *
   * @returns {Array}
   */
  const prepareBalanceSheetAssetDetails = ({ asset, contacts, count }) => {
    const content = [];
    content.push(
      helperPdfService.createSubHeader({
        title: `${asset.assetType.title.toUpperCase()} #${count}`
      })
    );
    content.push({
      table: {
        widths: ['25%', '25%', '25%', '25%'],
        body: [
          [
            {
              text: [
                { text: 'Balance sheet item\n', style: 'label' },
                {
                  text: asset?.name || '-',
                  style: 'value'
                }
              ]
            },
            {
              text: [
                { text: 'As at date\n', style: 'label' },
                {
                  text: asset.getSetAsAtDate(
                    $rootScope.CurrentTimeZone(),
                    $rootScope.CurrentLocale()
                  ),
                  style: 'value'
                }
              ]
            },
            {
              text: [
                { text: 'Value\n', style: 'label' },
                {
                  text: helperService
                    .isNumber(asset?.value, true)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ]
            },
            ''
          ],
          [
            {
              text: [
                {
                  text: 'Ownership\n',
                  style: 'label'
                },
                {
                  text: helperService.getOwnerships({
                    contacts,
                    ownership: asset.ownership
                  }),
                  style: 'value'
                }
              ],
              colSpan: 4
            },
            '',
            '',
            ''
          ]
        ]
      },
      layout: 'noBorders'
    });
    return content;
  };

  /**
   * Prepare assets details.
   *
   * @param {Array} assets
   * @param {Array} contacts
   * @param {Array} homeLoanSecurities
   * @param {Array} lenders
   * @param {Object} workflow
   *
   * @returns {Array}
   */
  const prepareAssetsDetails = ({
    assets,
    contacts,
    homeLoanSecurities,
    lenders,
    workflow
  }) => {
    const content = [];
    if (assets?.length) {
      content.push(
        helperPdfService.createHeader({
          title: 'ASSETS',
          pageBreak: 'before'
        })
      );
      let ownerOccupierPropertyAddressCount = 0;
      let investmentPropertyAddressCount = 0;
      let vehicleMakeAndModelCount = 0;
      let bankAccountsCount = 0;
      let homeContentsCount = 0;
      let kiwiSaverCount = 0;
      let superfundInstitutionCount = 0;
      let sharesCount = 0;
      let otherCount = 0;
      let balanceSheetCount = 0;
      const len = assets.length;
      for (let a = 0; a < len; a += 1) {
        const asset = assets[a];
        if (helperService.isAssetTypeOwnerOccupied(asset.assetType)) {
          ownerOccupierPropertyAddressCount += 1;
          content.push(
            prepareOwnerOccupiedAssetDetails({
              asset,
              contacts,
              homeLoanSecurities,
              workflow,
              count: ownerOccupierPropertyAddressCount
            })
          );
        }
        if (helperService.isAssetTypeInvestment(asset.assetType)) {
          investmentPropertyAddressCount += 1;
          content.push(
            prepareInvestmentAssetDetails({
              asset,
              contacts,
              homeLoanSecurities,
              workflow,
              count: investmentPropertyAddressCount
            })
          );
        }
        if (helperService.isAssetTypeVehicle(asset.assetType)) {
          vehicleMakeAndModelCount += 1;
          content.push(
            prepareVehicleAssetDetails({
              asset,
              contacts,
              homeLoanSecurities,
              count: vehicleMakeAndModelCount
            })
          );
        }
        if (helperService.isAssetTypeBankAccount(asset.assetType)) {
          bankAccountsCount += 1;
          content.push(
            prepareBankAccountAssetDetails({
              asset,
              contacts,
              lenders,
              count: bankAccountsCount
            })
          );
        }
        if (helperService.isAssetTypeHomeContents(asset.assetType)) {
          homeContentsCount += 1;
          content.push(
            prepareHomeContentsAssetDetails({ asset, contacts, count: homeContentsCount })
          );
        }
        if (helperService.isAssetTypeKiwiSaver(asset.assetType)) {
          kiwiSaverCount += 1;
          content.push(
            prepareKiwiSaverAssetDetails({ asset, contacts, count: kiwiSaverCount })
          );
        }
        if (helperService.isAssetTypeSuperfund(asset.assetType)) {
          superfundInstitutionCount += 1;
          content.push(
            prepareSuperfundAssetDetails({
              asset,
              contacts,
              count: superfundInstitutionCount
            })
          );
        }
        if (helperService.isAssetTypeShares(asset.assetType)) {
          sharesCount += 1;
          content.push(prepareSharesAssetDetails({ asset, contacts, count: sharesCount }));
        }
        if (helperService.isAssetTypeOther(asset.assetType)) {
          otherCount += 1;
          content.push(prepareOtherAssetDetails({ asset, contacts, count: otherCount }));
        }
        if (helperService.isAssetTypeBalanceSheet(asset.assetType)) {
          balanceSheetCount += 1;
          content.push(
            prepareBalanceSheetAssetDetails({ asset, contacts, count: balanceSheetCount })
          );
        }
      }

      content.push(helperPdfService.createSubHeader({ title: 'TOTAL ASSETS' }));
      content.push({
        table: {
          widths: ['25%', '25%', '25%', '25%'],
          body: [
            [
              {
                text: [
                  {
                    text: 'Total assets\n',
                    style: 'label'
                  },
                  {
                    text: assetsService
                      .getTotalAssets(assets)
                      .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                    style: 'value'
                  }
                ],
                colSpan: 2
              },
              '',
              '',
              ''
            ]
          ]
        },
        layout: 'noBorders'
      });
    }
    return content;
  };

  return {
    prepareAssetsDetails,
    prepareOwnerOccupiedAssetDetails,
    prepareInvestmentAssetDetails,
    prepareVehicleAssetDetails,
    prepareBankAccountAssetDetails,
    prepareHomeContentsAssetDetails,
    prepareKiwiSaverAssetDetails,
    prepareSuperfundAssetDetails,
    prepareSharesAssetDetails,
    prepareOtherAssetDetails,
    prepareBalanceSheetAssetDetails
  };
};
